<section class="bg-primary-dark">
    <app-landing-page-hero-shot></app-landing-page-hero-shot>
    <app-landing-page-curve
        class="text-primary-dark bg-alice-blue"
        [direction]="['right', 'up']"
    ></app-landing-page-curve>
</section>

<section>
    <app-landing-page-mission />
</section>

<section>
    <app-landing-page-wagon-tracking></app-landing-page-wagon-tracking>

    <app-landing-page-curve
        class="text-alice-blue bg-white"
        [direction]="['left', 'up']"
    ></app-landing-page-curve>
</section>

<section class="bg-white">
    <app-landing-page-fleet-management />
</section>

<section class="bg-primary-dark">
    <app-landing-page-demo-request />
</section>

<section class="bg-alice-blue">
    <app-landing-page-planning />
    <app-landing-page-booking />
</section>

<section class="bg-white">
    <app-landing-page-partners />
    <app-landing-page-curve
        class="text-alice-blue bg-white"
        [direction]="['right', 'down']"
    ></app-landing-page-curve>
</section>

<section class="bg-alice-blue">
    <app-landing-page-quotes />
    <app-landing-page-faq />
</section>

<section class="bg-primary-dark">
    <app-landing-page-curve
        class="text-alice-blue bg-primary-dark"
        [direction]="['left', 'up']"
    ></app-landing-page-curve>

    <app-landing-page-demo-request />
</section>
